<template>
	<div class="robat-main-box" v-if="show2">
		<div :class="name === 'xunidianchang2' ? 'GLMBoxXunidianchang2' : 'GLMBox1'" >
			<GLM :isActive="show2" @animation="animation" @isPlaying="handlePlayingStatusChange" />
		</div>
		<img :class="name === 'xunidianchang2' ? 'humanXunidianchang2' : 'human'" v-if="isSpeaking" src="@/assets/images/exposition/humannewa.png" alt=""
			>
		<img :class="name === 'xunidianchang2' ? 'humanXunidianchang2' : 'human'"  v-if="!isSpeaking" src="@/assets/images/exposition/humannew.png" alt=""
		@click="clicktrue1()" style="z-index: 111111111111111111;"
		>
	</div>
</template>

<script>
	import { Value } from 'sass'
import GLM from './GLM/index1.vue'

	export default {
		components: {
			GLM
		},
		data() {
			return {
				show2:true,
				isSpeaking: false,
				name:this.$route.name
			}
		},
		beforeCreate() {
			let fromPath = localStorage.getItem('bigScreen::fromPath')
			let playCount = parseInt(localStorage.getItem('bigScreen::playCount') || 0, 10)
			if (fromPath && ++playCount >= 2) {
				localStorage.setItem('bigScreen::playCount', '0')
				localStorage.setItem('bigScreen::fromPath', '')
				location.reload()
			} else {
				localStorage.setItem('bigScreen::playCount', playCount + '')
			}
		},
		created() {
			// if (this.isMobile()) {
			// 	location.href = 'https://mtest.gclme.com/pages/message/ai2/ai'
			// }
		},
		mounted() {
			console.log(this.$route.name,'this.$route.name',"name：",this.name)
			this.$EventBus.$on('clicktrue', (show1) => {
				  // this.clicktrue1(show1)
					console.log(show1, 'this.show1this.show1this.show1111111111111')
					if (show1) {
						this.show2 = true;
					} else {
						this.show2 = false;
					}
					
				})

			console.log('this.$route===========', this.$route)
			let {
				fromUser,
				scaleY
			} = this.$route.query
			fromUser ? sessionStorage.setItem('fromUser', fromUser) : ''
			scaleY ? localStorage.setItem('bigScreen::scaleY', scaleY) : ''

			let that = this
			this.fromUser = sessionStorage.getItem('fromUser')
			document.title = '移动能源光储充换车云一体化大屏'
			//初始化自适应  ----在刚显示的时候就开始适配一次
			// that.handleScreenAuto();
			//绑定自适应函数   ---防止浏览器栏变化后不再适配
			window.onresize = (function() {
				// that.handleScreenAuto()
			});
		},
		deleted() {
			window.onresize = null;
		},
		methods: {
			clicktrue1(){
				this.show2 = !this.show2;
				this.$EventBus.$emit('clicktrue2', this.show2)
				// localStorage.setItem('this.show2',this.show2)
				// console.log(this.show2, 'this.show2getShow2getShow2')
				
			},
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					);
				return flag;
			},
			//数据大屏自适应函数
			handleScreenAuto() {
				const designDraftWidth = 3840; //设计稿的宽度
				const designDraftHeight = 1620; //设计稿的高度
				//根据屏幕的变化适配的比例
				const scale = document.documentElement.clientWidth / document.documentElement.clientHeight <
					designDraftWidth / designDraftHeight ?
					(document.documentElement.clientWidth / designDraftWidth) :
					(document.documentElement.clientHeight / designDraftHeight);
				//缩放比例

				console.log(scale)

				// document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`;
				let scaleY = parseFloat(localStorage.getItem('bigScreen::scaleY')) || 1
				if (sessionStorage.getItem('fromUser') == 'guizhou') {
					document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * 1.6}) translate(-50%)`;
				} else {
					document.querySelector('#screen').style.transform =
						`scale(${scale}, ${scale * scaleY}) translate(-50%)`;
				}

			},
			animation(e) {
				console.log(e, '父组件')
				this.pos = e
			},
			handlePlayingStatusChange(e) {
				console.log('handlePlayingStatusChange e:', e);
				this.isSpeaking = e;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.robat-main-box {
		.GLMBox1 {
			width: 1000px;
			height: 515px;
			position: absolute;
			bottom: 227px;
			left: 1312px;
			z-index: 99999999;
			background-image: url("~@/assets/images/exposition/Vector.png");
			opacity: 0.8;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.GLMBoxXunidianchang2{
			width: 1000px;
			height: 515px;
			position: absolute;
			bottom: 10px;
			left: 1500px;
			z-index: 99999999;
			background-image: url("~@/assets/images/exposition/Vector.png");
			opacity: 0.8;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.human {
			width: 12%;
			position: absolute;
			bottom: 5px;
			left: 64%;
			z-index: 100;
		}
		.humanXunidianchang2{
			width: 12%;
			position: absolute;
			bottom: -170px;
			left: 61%;
			z-index: 100;
		}

		.human1 {
			width: 12%;
		}
	}
</style>